<template>
  <div class="custom-pagination -pagination">
      <p class="-label -paragraph">{{ $t('LABEL.ROWS_PER_PAGE') }}</p>
      <div class="-wrapper-v-center -input-form">
        <div class="-per">
          <input id="rowsPerPage" 
            onKeyDown="return false" 
            class="-description" 
            type="number" 
            name="rowsPerPage" 
            min="10" max="50" 
            step="10" 
            v-model="rowsPerPage"
            @change="onChangeRPP">
        </div>
        <button type="button" name="btnFirst" :disabled="disableFirst" @click="clickHandler($event)"><md-icons :name="'first_page_black_24dp'"/></button>
        <button type="button" name="btnPrev" :disabled="disableFirst" @click="clickHandler($event)"><md-icons :name="'chevron_left_black_24dp'"/></button>
        <input id=txtCurPage type="number" name="txtCurPage" class="-input" v-on:keyup.enter="submit" v-model="numCurPage" >
        <p class="-description">{{ $t('LABEL.OF') }} {{pageCount}}</p>
        <button type="button" name="btnNext" :disabled="disableLast" @click="clickHandler($event)"><md-icons :name="'chevron_right_black_24dp'"/></button>
        <button type="button" name="btnLast" :disabled="disableLast" @click="clickHandler($event)"><md-icons :name="'last_page_black_24dp'"/></button>
      </div>
  </div>
</template>

<script>
import MdIcons from "../../assets/icons/MdIcons.vue";

export default {
    name: "customPagination",
    components: {
      MdIcons
    },
    data() {
      return {
        numCurPage: 1,
        rowsPerPage:10
      }
    },
    computed: {
      disableFirst() {
        return this.numCurPage <= 1;
      },
      disableLast() {
        return this.numCurPage >= this.pageCount;
      },
    },
    watch: {
      cpCurrentPage(newVal, olv) {
        this.numCurPage = newVal;
      }
    },
    props: {
        cpRowsPerPage: {
            type: Number,
            default: 10,
        },
        cpCurrentPage: {
            type: Number,
            default: 1,
        },
        callSetCurPage: {
            type: Function,
            default: (currentPage)=> {console.log(currentPage)}
        },
        callSetRowsPerPage: {
            type: Function,
            default: (rowsPerPage)=> {console.log(rowsPerPage)}
        },
        pageCount: {
            type: Number,
            default: 1
        },
    },
    mounted() {
      this.rowsPerPage = parseInt(this.cpRowsPerPage);
      this.numCurPage = parseInt(this.cpCurrentPage);
      if (this.cpCurrentPage < 1) {
        this.numCurPage = 1;
      }
    },
    methods: {
      onChangeRPP() {
        this.numCurPage = 1;
        const currentPagination = {
          currentPage: this.numCurPage,
          rowsPerPage: parseInt(this.rowsPerPage)
        }
        this.callSetRowsPerPage(currentPagination);
      },
      submit() {
        if (this.numCurPage > this.pageCount) {
          this.numCurPage = this.pageCount;
        } else if (this.numCurPage < 1) {
          this.numCurPage = 1;
        }
        this.callSetCurPage(parseInt(this.numCurPage));
      },
      clickHandler(btn) {
        switch(btn.currentTarget.name) {
          case "btnFirst":
            this.numCurPage = 1;
            //disablePrev
            //disableFirst
          break;
          case "btnLast":
            this.numCurPage = this.pageCount;
            // disableNext
            // disableLast
          break;
          case "btnPrev":
            if (this.numCurPage > 1) {
              this.numCurPage --;
              //disablePrev
            }
          break;
          case "btnNext":
            if (this.numCurPage < this.pageCount) {
              this.numCurPage ++;
              // disableNext
            }
          break;
        }
        this.callSetCurPage(this.numCurPage);
      }
    }
}
</script>

<style scoped>
button:disabled {
  cursor: default;
}
button:disabled {
  border-radius: 4px;
}
.custom-pagination {
    align-items: center;
    padding-top: 12px;
    padding-right: 16px;
    height: 24px;
    font-family: 'Noto Sans Korean', serif;
}
.custom-pagination input.-input {
  text-align: center;
  font-size: 12px;
}

.custom-pagination button:hover {
    border-style: solid;
    border-width: 1px;
    border-radius: 4px !important;
    padding: 4px;
    border-color: #7d8590;
}

.custom-pagination button:disabled,
.custom-pagination button[disabled] {
    border: none;
    padding: 0;
}

/* Chrome, Safari, Edge, Opera */
input#txtCurPage::-webkit-outer-spin-button,
input#txtCurPage::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input#rowsPerPage::-webkit-outer-spin-button,
input#rowsPerPage::-webkit-inner-spin-button {
  opacity: 1;
}

/* Firefox */
input#txtCurPage[type=number] {
  -moz-appearance: textfield;
}
input#rowsPerPage[type=number] {
  opacity: 1;
  width: 35px;
}

.custom-pagination {
  position: absolute;
  right: 10px;
}

.custom-pagination p.-label.-paragraph {
  font-weight: 500;
}
.custom-pagination svg {
    fill: #7d8590;
    height: 16px;
    width: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/common/customPagination.vue